import { create } from 'zustand';

/**
 * Scene phases for the Ribbon Symphony welcome screen.
 *
 *  - intro : ribbons orbit slowly and follow the cursor.
 *  - hover : the visitor is hovering the CTA; nearby ribbons converge.
 *  - enter : the CTA was clicked; ribbons sweep toward the camera and the
 *            camera flies through them into the site.
 */
export type WelcomePhase = 'intro' | 'hover' | 'enter';

interface WelcomeState {
  phase: WelcomePhase;
  setPhase: (phase: WelcomePhase) => void;
}

export const useWelcomeStore = create<WelcomeState>((set) => ({
  phase: 'intro',
  setPhase: (phase) => set({ phase }),
}));
